<lib-form-field-container class="w-100"
    [isOptional]="isOptionalOverride"
    [kind]="FormContainerKind.None">

    <ng-content label select="[label]"></ng-content>
    <ng-content supportingText select="[supportingText]"></ng-content>
    <ng-container readOnly>
        <div #providedReadOnly class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">{{ formControl.value }}</div>
    </ng-container>

    <mat-button-toggle class="sb-pill-select"
        [attr.aria-labelledby]="ariaLabel ? null : formFieldID + '-label'"
        [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
        [attr.aria-label]="ariaLabel || null"
        [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
        [attr.aria-required]="formControl.isRequired"
        [ngClass]="{'sb-pill-select-mobile': isMobile, 'sb-pill-select-disabled': disabled}"
        [checked]="selected || viewControl.value"
        [value]="value"
        [disableRipple]="true"
        [disabled]="viewControl.disabled"
        [attr.data-sb-qa]="qaTag"
        (click)="$event.stopPropagation()"
        (change)="ChangeEvent($event)">
        <div class="sb-pill-select-inner">
            @if (selected || viewControl.value) {
                <lib-icon class="sb-pill-select-check-icon" [icon]="Icon.Common.Check" [size]="IconSize.ExtraSmall"></lib-icon>
            } @else if (isMobile) {
                <lib-icon class="sb-pill-select-remove-icon" [icon]="Icon.Common.Remove" [size]="IconSize.ExtraSmall"></lib-icon>
            }
            <p [ngClass]="{'typography-label-medium': isMobile, 'typography-label-large': !isMobile, 'pe-1': (selected || viewControl.value) && !isMobile}">
                <ng-content></ng-content>
            </p>
        </div>
    </mat-button-toggle>

</lib-form-field-container>
